import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-global space-y-6" }
const _hoisted_2 = { class: "page-title text-gray-800" }
const _hoisted_3 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_4 = {
  key: 2,
  class: "text-gray-500"
}

import BackButton from "@/components/common/BackButton.vue";
import { onBeforeUnmount, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import EntityApprovalDetailsContent from "@/components/entityApproval/EntityApprovalDetailsContent.vue";
import EntityApprovalRejectModal from "@/components/entityApproval/EntityApprovalRejectModal.vue";
import EntityApprovalDataService from "@/services/common/entityApproval/EntityApprovalDataService";
import { EntityApprovalActions } from "@/store/modules/entityApproval/actions";
import {
  IEntityApprovalRequest,
  isEntityApprovalId,
} from "@/types/common/entityApproval/EntityApproval";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const store = useStore();
const toast = useToast();

const request = ref<IEntityApprovalRequest | null>(null);
const loading = ref(false);
const loadFailed = ref(false);
const rejectModalShow = ref(false);
const rejectTargetId = ref<string | null>(null);
let loadSequence = 0;

const loadDetails = async () => {
  const sequence = ++loadSequence;
  const id = route.params.id;
  request.value = null;
  loadFailed.value = false;
  loading.value = false;

  if (!isEntityApprovalId(id)) {
    loadFailed.value = true;
    return;
  }

  loading.value = true;
  try {
    const response = await EntityApprovalDataService.get(id);
    if (sequence === loadSequence) request.value = response.data.data;
  } catch {
    if (sequence === loadSequence) loadFailed.value = true;
  } finally {
    if (sequence === loadSequence) loading.value = false;
  }
};

const approve = async (id: string) => {
  try {
    await store.dispatch(EntityApprovalActions.APPROVE, id);
    toast.success(t("entityApproval.approveSuccess"));
    await loadDetails();
  } catch {
    toast.error(t("entityApproval.approveError"));
  }
};

const openReject = (id: string) => {
  rejectTargetId.value = id;
  rejectModalShow.value = true;
};

const confirmReject = async (reason?: string) => {
  if (rejectTargetId.value == null) {
    return;
  }

  try {
    await store.dispatch(EntityApprovalActions.REJECT, {
      id: rejectTargetId.value,
      data: reason ? { reason } : undefined,
    });
    toast.success(t("entityApproval.rejectSuccess"));
    rejectModalShow.value = false;
    rejectTargetId.value = null;
    await loadDetails();
  } catch {
    toast.error(t("entityApproval.rejectError"));
  }
};

watch(() => route.params.id, loadDetails, { immediate: true });
onBeforeUnmount(() => {
  loadSequence++;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'EntityApprovalList' },
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)("entityApproval.detailsTitle")), 1),
      (loading.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(t)("entityApproval.loading")), 1))
        : (request.value)
          ? (_openBlock(), _createBlock(EntityApprovalDetailsContent, {
              key: 1,
              request: request.value,
              onApprove: approve,
              onReject: openReject
            }, null, 8, ["request"]))
          : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(loadFailed.value ? _unref(t)("entityApproval.loadError") : _unref(t)("common.noData")), 1))
    ]),
    _createVNode(EntityApprovalRejectModal, {
      show: rejectModalShow.value,
      onHide: _cache[0] || (_cache[0] = ($event: any) => (rejectModalShow.value = false)),
      onConfirm: confirmReject
    }, null, 8, ["show"])
  ], 64))
}
}

})